<template>
  <div
    class="absolute flex flex-col gap-6 w-[650px] p-6 rounded-lg bg-white shadow-default"
  >
    <div class="flex gap-4">
      <div
        class="info flex justify-center items-center flex-shrink-0 w-12 h-12 rounded-sm"
      >
        <InfoIcon />
      </div>
      <div>
        <h2 class="modal-heading">
          {{ changeCase('clear cache', ElementE.TITLE) }}
        </h2>
        <p class="modal-content mt-1">
          {{ changeCase('are you sure you want to clear the cache?', ElementE.SUBTITLE) }}
        </p>
      </div>
    </div>

    <div class="flex gap-4 self-end">
      <button class="btn-secondary is-btn-size-default" @click="$emit('close')">
        {{ changeCase('cancel', ElementE.BUTTON) }}
      </button>
      <button class="btn-primary is-btn-size-default" @click="clearCache">
        {{ changeCase('clear cache', ElementE.BUTTON) }}
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import InfoIcon from "../icons/InfoIcon.vue";
import axiosClient from "@/axiosClient";
import { changeCase } from '../../helpers';
import { ElementE } from '../../enums';

export default defineComponent({
  name: "ClearCacheModal",
  components: { InfoIcon },
  emits: ['close', 'clearCache'],
  methods:{
    clearCache(){
      axiosClient
        .get("v3/clearcache")
        .then((res) => {
          this.$emit('clearCache', 'Cache cleared');
        }).catch(e =>{
        console.log(e)
      })
    }
  },
  data() {
    return {
      changeCase: changeCase,
      ElementE: ElementE,
    }
  },
});
</script>
